import { render, staticRenderFns } from "./CustomerLevel.vue?vue&type=template&id=dfd251cc"
import script from "./CustomerLevel.vue?vue&type=script&lang=js"
export * from "./CustomerLevel.vue?vue&type=script&lang=js"
import style0 from "./CustomerLevel.vue?vue&type=style&index=0&id=dfd251cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports